import React, { useState, useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import PdfView from '../PdfView';
import 'swiper/css';
import '../../style/banner.css';
import '../../iconfont/iconfont.css';
const shouce = require('../../assets/shouce.png');
const bannerTitle = require('../../assets/bnenr-title.png');

function Banner() {
    // 模态框关闭
    const [isOpen, setIsOpen] = useState(false);
    // 模块距离
    const [spaceBetween, setSpaceBetween] = useState(50);
    // 可预览个数
    const [slidesPerView, setSlidesPerView] = useState(5);

    useEffect(() => {
        // 手机端设置
        if (window.innerWidth > 768) {
            setSpaceBetween(100);
            setSlidesPerView(5);
        } else {
            setSpaceBetween(100);
            setSlidesPerView(2);
        }
    }, [])

    return (
        <div className="banner">
            <img className="banner-title" src={bannerTitle} alt="bannerTitle" />
            <div className="banner-content">
                <div className="banner-content__souce swiper-container">
                    <Swiper
                        className="banner-content__souce--box"
                        spaceBetween={spaceBetween}
                        slidesPerView={slidesPerView}
                        autoplay={{ delay: 5000, disableOnInteraction: false }}
                    >
                        <SwiperSlide className="source-item" key={1}>
                            <span className="icon iconfont icon-quyumianji"></span>
                            <span className="num">
                                314.9
                                <span className="unit">km²</span>
                            </span>
                            <span className="name">行政区域面积</span>
                        </SwiperSlide>
                        <SwiperSlide className="source-item" key={2}>
                            <span className="icon iconfont icon-changzhurenkou"></span>
                            <span className="num">
                                3.54
                                <span className="unit">万人</span>
                            </span>
                            <span className="name">常住人口</span>
                        </SwiperSlide>
                        <SwiperSlide className="source-item" key={3}>
                            <span className="icon iconfont icon-shequ"></span>
                            <span className="num">
                                1
                                <span className="unit">个</span>
                            </span>
                            <span className="name">社区(居)</span>
                        </SwiperSlide>
                        <SwiperSlide className="source-item" key={4}>
                            <span className="icon iconfont icon-hangzhengcun"></span>
                            <span className="num">
                                10
                                <span className="unit">个</span>
                            </span>
                            <span className="name">行政村</span>
                        </SwiperSlide>
                        <SwiperSlide className="source-item" key={5}>
                            <span className="icon iconfont icon-GDPzengsu"></span>
                            <span className="num">
                                26.38
                               <span className="unit">亿元</span>
                            </span>
                            <span className="name">GDP总额</span>
                        </SwiperSlide>
                    </Swiper>
                </div>
                <div
                    className="banner-content__manual"
                    onClick={() => setIsOpen(!isOpen)}
                >
                    <span className="banner-content__manual--text">育才区招商手册</span>
                    <img className="banner-content__manual--icon" src={shouce} alt="logo" />
                </div>
            </div>
            <PdfView isClose={isOpen} onOpen={(props) => setIsOpen(props)} />
        </div>
    );
}

export default Banner;
